export const WEEK_REPORT_ID = 'week';
